import { useState } from "react";
import { faqs } from "@/mocks/news";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" aria-label="常见问题" className="w-full bg-background-100/70 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="text-xs font-label text-primary-600 tracking-widest mb-2">FAQ</p>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
              关于瓜田速递
            </h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              第一次来？这几个问题基本能帮你搞清楚我们是谁、怎么更新、怎么投稿。
              还有疑问可以直接发邮件给我们。
            </p>
          </div>

          <div className="lg:col-span-8">
            <dl className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.q} className="border-b border-background-200 last:border-b-0">
                    <dt>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="w-full flex items-center justify-between gap-4 px-4 md:px-6 py-4 text-left hover:bg-background-100/60 transition-colors cursor-pointer"
                      >
                        <span className="font-heading text-sm md:text-base font-bold text-foreground-900">
                          {faq.q}
                        </span>
                        <i
                          className={`shrink-0 text-lg text-primary-500 transition-transform ${
                            isOpen ? "ri-subtract-line" : "ri-add-line"
                          }`}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </dt>
                    {isOpen && (
                      <dd className="px-4 md:px-6 pb-5 -mt-1 text-sm text-foreground-600 leading-relaxed">
                        {faq.a}
                      </dd>
                    )}
                  </div>
                );
              })}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}